import { useEffect } from 'react';
import { Chip } from '@material-tailwind/react';
import dayjs from 'dayjs';
import { DialogUI } from '../Interface';
import { KanbanType } from '../../config/kanban';
import { ColorPicker } from '../../config/ColorPicker';

const Field = ({ label, value, chipColor, isChip, dateType }) => {
  let formattedValue = value;
  if (dateType) {
    switch (dateType) {
      case 'date':
        formattedValue = dayjs(value).format('YYYY-MM-DD');
        break;
      case 'datetime':
        formattedValue = dayjs(value).format('YYYY-MM-DD HH:mm:ss');
        break;
      case 'time':
        formattedValue = dayjs(value).format('HH:mm:ss');
        break;
      default:
        formattedValue = value;
    }
  }
  if (isChip) {
    return (
      <div>
        <h4 className="font-semibold">{label}</h4>
        <div className="flex">
          <Chip
            value={formattedValue}
            className="rounded-full"
            variant="ghost"
            style={{ backgroundColor: chipColor }}
          />
        </div>
      </div>
    );
  } else {
    return (
      <div className="mb-3">
        <div>
          <h4 className="font-semibold">{label}</h4>
          <p>{formattedValue}</p>
        </div>
      </div>
    );
  }
};

const Dialog = ({
  open,
  handleClose,
  data,
  type,
  changed,
  SpecificComponent,
  getViewField,
  dialogParams,
  projectState,
  resourceOneState,
  taskFeedbackState,
  simpleTaskState,
  projectTasksState,
  resourceThreeState,
}) => {
  const { taskChanged, setTaskChanged } = changed;

  useEffect(() => {
    if (data) {
      if (type === KanbanType.PROJECT) {
        projectState.setSelectedValues(data);
      } else if (type === KanbanType.RESOURCE) {
        resourceOneState.setSelectedValues(data);
      } else if (type === KanbanType.FEEDBACK) {
        taskFeedbackState.setSelectedValues(data);
      } else if (type === KanbanType.TASK) {
        simpleTaskState.setSelectedValues(data);
      } else if (type === KanbanType.TASKLIST) {
        projectTasksState.setSelectedValues(data);
      } else if (type === KanbanType.RESOURCETHREE) {
        resourceThreeState.setSelectedValues(data);
      }
    }
  }, [data, type]);

  useEffect(() => {
    if (!open) {
      if (type === KanbanType.PROJECT) {
        projectState.setViewField(true);
      } else if (type === KanbanType.RESOURCE) {
        resourceOneState.setViewField(true);
      } else if (type === KanbanType.FEEDBACK) {
        taskFeedbackState.setViewField(true);
      } else if (type === KanbanType.TASK) {
        simpleTaskState.setViewField(true);
      } else if (type === KanbanType.TASKLIST) {
        projectTasksState.setViewField(true);
      } else if (type === KanbanType.RESOURCETHREE) {
        resourceThreeState.setViewField(true);
      }
    }
  }, [open]);

  const getFieldValue = (obj, path) => {
    return path.split('.').reduce((acc, part) => {
      if (Array.isArray(acc)) {
        return acc.map((item) => item[part]);
      } else {
        return acc ? acc[part] : null;
      }
    }, obj);
  };

  const getChipColor = (fieldColor) => {
    if (!fieldColor) return null;
    const color = getFieldValue(data, fieldColor);
    const colorObj = ColorPicker.find((col) => col.colorName === color);
    return colorObj ? colorObj.colorCode : color;
  };

  return (
    <DialogUI
      open={open}
      onClose={SpecificComponent && !getViewField() ? () => {} : handleClose}
      headerContent={data.name}
      closeBtn={true}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '1500px',
            mx: 1,
          },
        },
      }}
    >
      <div className="mt-5">
        {SpecificComponent ? (
          <div className="-mt-5">
            <SpecificComponent
              projectState={projectState}
              resourceOneState={resourceOneState}
              taskFeedbackState={taskFeedbackState}
              simpleTaskState={simpleTaskState}
              projectTasksState={projectTasksState}
              resourceThreeState={resourceThreeState}
              dialog={{
                handleClose: handleClose,
                taskChanged: taskChanged,
                setTaskChanged: setTaskChanged,
                feedbackIsUpdate: true,
                isUpdate: true,
              }}
            />
          </div>
        ) : (
          <div className="block grid-cols-4 gap-x-4 gap-y-2 mx-4 md:grid text-labelColor">
            {dialogParams &&
              dialogParams.map((item, index) => (
                <Field
                  key={index}
                  label={item.label}
                  value={getFieldValue(data, item.fieldName) || 'Nincs megadva.'}
                  chipColor={getChipColor(item.color)}
                  isChip={item.view === 'chip'}
                  dateType={item.dateType}
                />
              ))}
          </div>
        )}
      </div>
    </DialogUI>
  );
};

export default Dialog;
